import React, { useEffect } from 'react';
import './ReportSection.css';
import { useWorkshops } from '../WorkshopContext';
import ReportSectionGeneral from './ReportSectionGeneral';
import ReportSectionActivity1 from './ReportSectionActivity1';
import ReportSectionActivity2 from './ReportSectionActivity2';
import ReportSectionActivity3 from './ReportSectionActivity3';
import ReportSectionDownload from './ReportSectionDownload';

const ReportSection = () => {

  const { state, fetchWorkshopDetails } = useWorkshops();

  // Find the workshop in the array that matches lastClickedWorkshopId
  const selectedWorkshop = state.workshops.find(workshop => workshop.id === state.selectedWorkshopId);  
  // Hide report until a workshop is actually selected
  let isHidden = selectedWorkshop !== undefined ? '' : 'is-hidden';  

  useEffect(() => {
    if (state.selectedWorkshopId) {
      fetchWorkshopDetails(state.selectedWorkshopId);
    }    
  }, [state.selectedWorkshopId, fetchWorkshopDetails]);

  return (
    <div className={isHidden}>
      <div className="container">
        <ReportSectionGeneral
          selectedWorkshop={selectedWorkshop}
          selectedWorkshopDetails={state.selectedWorkshopDetails}/>
        <ReportSectionActivity1
          selectedWorkshop={selectedWorkshop}
          selectedWorkshopDetails={state.selectedWorkshopDetails} />
        <ReportSectionActivity2
          selectedWorkshop={selectedWorkshop}
          selectedWorkshopDetails={state.selectedWorkshopDetails}/>
        <ReportSectionActivity3
            selectedWorkshop={selectedWorkshop}
            selectedWorkshopDetails={state.selectedWorkshopDetails} />
        <ReportSectionDownload
            selectedWorkshop={selectedWorkshop}
            selectedWorkshopDetails={state.selectedWorkshopDetails} />
      </div>      
    </div>
  );
};

export default ReportSection;
